// import { LayoutDashboard, Trash2, CheckCircle, Clock, BarChart3, ScrollText } from "lucide-react";
// import DashboardLayout from "../../components/DashboardLayout";

// const cardGrid = {
//   display: "grid",
//   gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
//   gap: 14,
//   marginBottom: 24,
// };

// function StatCard({ label, value, sub, color = "var(--g600)", icon: Icon, delay }) {
//   return (
//     <div className={`fu ${delay}`} style={{
//       background: "#fff", borderRadius: 14,
//       border: "1px solid var(--ln)", padding: "18px 20px",
//       boxShadow: "0 1px 4px rgba(0,0,0,.04)",
//       display: "flex", flexDirection: "column", gap: 8,
//     }}>
//       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//         <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: ".6px", textTransform: "uppercase", color: "var(--mut)" }}>
//           {label}
//         </div>
//         {Icon && (
//           <div style={{ width: 32, height: 32, borderRadius: 9, background: "var(--g50)", display: "flex", alignItems: "center", justifyContent: "center" }}>
//             <Icon size={15} color="var(--g600)" strokeWidth={1.8} />
//           </div>
//         )}
//       </div>
//       <div style={{ fontSize: 28, fontWeight: 700, color, fontFamily: "'Outfit',sans-serif", lineHeight: 1 }}>
//         {value}
//       </div>
//       {sub && <div style={{ fontSize: 12, color: "var(--mut)" }}>{sub}</div>}
//     </div>
//   );
// }

// function ComingSoonCard({ title, desc, delay }) {
//   return (
//     <div className={`fu ${delay}`} style={{
//       background: "#fff", borderRadius: 14,
//       border: "1.5px dashed var(--ln)", padding: "20px",
//     }}>
//       <div style={{ display: "inline-flex", alignItems: "center", background: "#e3f2fd", borderRadius: 6, padding: "3px 10px", fontSize: 10, fontWeight: 700, letterSpacing: "1px", textTransform: "uppercase", color: "#1565c0", marginBottom: 10 }}>
//         Milestone 2
//       </div>
//       <div style={{ fontSize: 14, fontWeight: 600, color: "var(--ink)", marginBottom: 5 }}>{title}</div>
//       <div style={{ fontSize: 13, color: "var(--mut)", lineHeight: 1.6 }}>{desc}</div>
//     </div>
//   );
// }

// const NAV = [
//   { label: "Dashboard",     icon: LayoutDashboard, active: true },
//   { label: "Submissions",   icon: Trash2 },
//   { label: "Valet Status",  icon: CheckCircle },
//   { label: "Activity Logs", icon: ScrollText },
//   { label: "Reports",       icon: BarChart3 },
// ];

// export default function HOADashboard() {
//   // const { profile } = useAuth();
//   return (
//     <DashboardLayout role="hoa_admin" title="Property Dashboard" navItems={NAV}>

//       <div className="fu" style={{ marginBottom: 24 }}>
//         <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: "#1565c0", marginBottom: 6 }}>
//           HOA Admin Portal
//         </div>
//         <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 24, fontWeight: 500, color: "var(--ink)", marginBottom: 6 }}>
//           Property Overview
//         </h2>
//         <p style={{ fontSize: 13, color: "var(--mut)" }}>Daily operational summary for your property.</p>
//       </div>

//       <div className="fu d1" style={{ fontSize: 10, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: "var(--mut)", marginBottom: 12 }}>
//         Today's Summary
//       </div>
//       <div style={cardGrid}>
//         <StatCard label="Total Units"        value="—" sub="Live in M2" icon={LayoutDashboard} delay="d1" />
//         <StatCard label="Trash Submissions"  value="—" sub="Live in M2" color="#1565c0" icon={Trash2} delay="d2" />
//         <StatCard label="Completed"          value="—" sub="Live in M2" color="var(--g600)" icon={CheckCircle} delay="d3" />
//         <StatCard label="Last Activity"      value="—" sub="Live in M2" color="#e65100" icon={Clock} delay="d4" />
//       </div>

//       {/* Valet Status Banner */}
//       <div className="fu d3" style={{
//         background: "#fff", borderRadius: 14, border: "1px solid var(--ln)",
//         padding: "18px 20px", marginBottom: 24,
//         display: "flex", alignItems: "center", justifyContent: "space-between",
//         flexWrap: "wrap", gap: 12,
//       }}>
//         <div>
//           <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: ".6px", textTransform: "uppercase", color: "var(--mut)", marginBottom: 6 }}>
//             Current Valet Status
//           </div>
//           <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//             <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#bdbdbd" }} />
//             <span style={{ fontSize: 13.5, fontWeight: 500, color: "var(--mut)" }}>
//               Live status available in Milestone 2
//             </span>
//           </div>
//         </div>
//         <div style={{ background: "#e3f2fd", color: "#1565c0", fontSize: 12, fontWeight: 700, padding: "6px 14px", borderRadius: 8 }}>
//           Milestone 2
//         </div>
//       </div>

//       <div className="fu d4" style={{ fontSize: 10, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: "var(--mut)", marginBottom: 12 }}>
//         Milestone 2 Features
//       </div>
//       <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 12 }}>
//         <ComingSoonCard title="Live Submissions Feed"  desc="Real-time trash submissions from residents with unit & timestamp." delay="d1" />
//         <ComingSoonCard title="Valet Status Tracking" desc="See On My Way, On-Site, Completed status updates live." delay="d2" />
//         <ComingSoonCard title="Date Filter & History"  desc="View daily operational summaries by date range." delay="d3" />
//       </div>

//     </DashboardLayout>
//   );
// }


import { useState, useEffect, useCallback } from "react";
import {
  LayoutDashboard, Trash2, CheckCircle, Clock,
  BarChart3, ScrollText, Building2, ChevronLeft, ChevronRight
} from "lucide-react";
import DashboardLayout from "../../components/DashboardLayout";
import { useAuth } from "../../hooks/useAuth";
import { supabase } from "../../lib/supabaseClient";

// ─── Nav ──────────────────────────────────────────────────────────────────────
const NAV = [
  { label: "Dashboard", icon: LayoutDashboard, path: "/hoa/dashboard", active: true },
  { label: "Submissions", icon: Trash2, path: "/hoa/submissions" },
  { label: "Valet Status", icon: CheckCircle, path: "/hoa/valet-status" },
  { label: "Activity Logs", icon: ScrollText, path: "/hoa/logs" },
  { label: "Reports", icon: BarChart3, path: "/hoa/reports" },
];

// ─── Helpers ──────────────────────────────────────────────────────────────────
function getToday() {
  return new Date().toISOString().split("T")[0];
}

function formatDate(dateStr) {
  const d = new Date(dateStr + "T00:00:00");
  return d.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
}

function formatTime(isoStr) {
  return new Date(isoStr).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

// function addDays(dateStr, n) {
//   const d = new Date(dateStr + "T00:00:00");
//   d.setDate(d.getDate() + n);
//   return d.toISOString().split("T")[0];
// }

function addDays(dateStr, n) {
  const [y, m, d] = dateStr.split("-").map(Number);
  const date = new Date(y, m - 1, d); // local time, no timezone shift
  date.setDate(date.getDate() + n);
  const yy = date.getFullYear();
  const mm  = String(date.getMonth() + 1).padStart(2, "0");
  const dd  = String(date.getDate()).padStart(2, "0");
  return `${yy}-${mm}-${dd}`;
}

// ─── Valet Status Config ──────────────────────────────────────────────────────
function getValetStatusConfig(status) {
  switch (status) {
    case "on_the_way": return { label: "On The Way", dot: "#ff9800", color: "#e65100", bg: "#fff3e0", border: "#ffb74d" };
    case "on_site": return { label: "Arrived On-Site", dot: "#1565c0", color: "#1565c0", bg: "#e3f2fd", border: "#90caf9" };
    case "completed": return { label: "Service Completed", dot: "var(--g600)", color: "var(--g600)", bg: "var(--g50)", border: "var(--g200)" };
    default: return { label: "No Service Today", dot: "#bdbdbd", color: "var(--mut)", bg: "#fafafa", border: "var(--ln)" };
  }
}

// ─── Stat Card ────────────────────────────────────────────────────────────────
function StatCard({ label, value, sub, color = "var(--g600)", icon: Icon, delay }) {
  return (
    <div className={`fu ${delay}`} style={{
      background: "#fff", borderRadius: 14,
      border: "1px solid var(--ln)", padding: "18px 20px",
      boxShadow: "0 1px 4px rgba(0,0,0,.04)",
      display: "flex", flexDirection: "column", gap: 8,
    }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: ".6px", textTransform: "uppercase", color: "var(--mut)" }}>
          {label}
        </div>
        {Icon && (
          <div style={{ width: 32, height: 32, borderRadius: 9, background: "var(--g50)", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Icon size={15} color="var(--g600)" strokeWidth={1.8} />
          </div>
        )}
      </div>
      <div style={{ fontSize: 28, fontWeight: 700, color, fontFamily: "'Outfit',sans-serif", lineHeight: 1 }}>
        {value ?? "—"}
      </div>
      {sub && <div style={{ fontSize: 12, color: "var(--mut)" }}>{sub}</div>}
    </div>
  );
}

// ─── Date Navigator ───────────────────────────────────────────────────────────
function DateNavigator({ date, onChange }) {
  const isToday = date === getToday();
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <button onClick={() => onChange(addDays(date, -1))} style={{
        width: 32, height: 32, borderRadius: 8, border: "1.5px solid var(--ln)",
        background: "#fff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
      }}>
        <ChevronLeft size={16} color="var(--mut)" />
      </button>

      <div style={{
        padding: "6px 16px", borderRadius: 8, border: "1.5px solid var(--ln)",
        background: "#fff", fontSize: 13, fontWeight: 600, color: "var(--ink)",
        minWidth: 140, textAlign: "center",
      }}>
        {isToday ? `Today · ${formatDate(date)}` : formatDate(date)}
      </div>

      <button
        onClick={() => onChange(addDays(date, 1))}
        disabled={isToday}
        style={{
          width: 32, height: 32, borderRadius: 8, border: "1.5px solid var(--ln)",
          background: "#fff", cursor: isToday ? "not-allowed" : "pointer",
          display: "flex", alignItems: "center", justifyContent: "center",
          opacity: isToday ? 0.4 : 1,
        }}
      >
        <ChevronRight size={16} color="var(--mut)" />
      </button>

      {!isToday && (
        <button onClick={() => onChange(getToday())} style={{
          padding: "6px 12px", borderRadius: 8, border: "1.5px solid var(--g300)",
          background: "var(--g50)", cursor: "pointer",
          fontSize: 12, fontWeight: 700, color: "var(--g600)",
        }}>
          Today
        </button>
      )}
    </div>
  );
}

// ─── Main Dashboard ───────────────────────────────────────────────────────────
export default function HOADashboard() {
  const { profile } = useAuth();
  const propertyId = profile?.property_id;

  const [selectedDate, setSelectedDate] = useState(getToday());
  const [propertyInfo, setPropertyInfo] = useState(null);
  const [valetStatus, setValetStatus] = useState(null);
  const [submissions, setSubmissions] = useState([]);
  const [servicesCount, setServicesCount] = useState(0);
  const [lastActivity, setLastActivity] = useState(null);
  const [loading, setLoading] = useState(true);

  // ── Fetch property info (once) ──
  useEffect(() => {
    if (!propertyId) return;
    supabase
      .from("properties")
      .select("id, name, total_units")
      .eq("id", propertyId)
      .maybeSingle()
      .then(({ data }) => setPropertyInfo(data));
  }, [propertyId]);

  // ── Fetch all data for selected date ──
  const fetchData = useCallback(async () => {
    if (!propertyId) return;
    setLoading(true);

    const dateStart = `${selectedDate}T00:00:00`;
    const dateEnd = `${selectedDate}T23:59:59`;

    // 1. Valet status for selected date
    const { data: vs } = await supabase
      .from("valet_status")
      .select("status, updated_at")
      .eq("property_id", propertyId)
      .eq("service_date", selectedDate)
      .maybeSingle();
    setValetStatus(vs || null);

    // 2. Resident trash submissions
    const { data: subs } = await supabase
      .from("activity_logs")
      .select("id, created_at, metadata, user_id")
      .eq("property_id", propertyId)
      .eq("action", "resident_trash_submitted")
      .gte("created_at", dateStart)
      .lte("created_at", dateEnd)
      .order("created_at", { ascending: false });
    setSubmissions(subs || []);

    // 3. Services completed count
    // const { data: svcs } = await supabase
    //   .from("activity_logs")
    //   .select("id")
    //   .eq("property_id", propertyId)
    //   .eq("action", "valet_status_changed")
    //   .gte("created_at", dateStart)
    //   .lte("created_at", dateEnd);
    // // Count only "completed" entries
    // setServicesCount(
    //   vs?.status === "completed" ? 1 : 0
    // );
    // 3. Services completed count
    setServicesCount(
      vs?.status === "completed" ? 1 : 0
    );

    // 4. Last activity timestamp
    const { data: lastAct } = await supabase
      .from("activity_logs")
      .select("created_at")
      .eq("property_id", propertyId)
      .gte("created_at", dateStart)
      .lte("created_at", dateEnd)
      .order("created_at", { ascending: false })
      .limit(1)
      .maybeSingle();
    setLastActivity(lastAct?.created_at || null);

    setLoading(false);
  }, [propertyId, selectedDate]);

  useEffect(() => { fetchData(); }, [fetchData]);

  // ── Realtime: valet_status ──
  useEffect(() => {
    if (!propertyId) return;
    const channel = supabase
      .channel("hoa_valet_status")
      .on("postgres_changes", {
        event: "*", schema: "public", table: "valet_status",
        filter: `property_id=eq.${propertyId}`,
      }, () => fetchData())
      .subscribe();
    return () => supabase.removeChannel(channel);
  }, [propertyId, fetchData]);

  // ── Realtime: activity_logs ──
  useEffect(() => {
    if (!propertyId) return;
    const channel = supabase
      .channel("hoa_activity_logs")
      .on("postgres_changes", {
        event: "INSERT", schema: "public", table: "activity_logs",
        filter: `property_id=eq.${propertyId}`,
      }, () => fetchData())
      .subscribe();
    return () => supabase.removeChannel(channel);
  }, [propertyId, fetchData]);

  const vsConfig = getValetStatusConfig(valetStatus?.status);
  const isToday = selectedDate === getToday();

  return (
    <DashboardLayout role="hoa_admin" title="Property Dashboard" navItems={NAV}>

      {/* Header */}
      <div className="fu" style={{ marginBottom: 24 }}>
        <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: "#1565c0", marginBottom: 6 }}>
          HOA Admin Portal
        </div>
        <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
          <div>
            <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 24, fontWeight: 500, color: "var(--ink)", marginBottom: 4 }}>
              Property Overview
            </h2>
            <p style={{ fontSize: 13, color: "var(--mut)" }}>
              {propertyInfo
                ? <><Building2 size={12} style={{ marginRight: 4, verticalAlign: "middle" }} /><strong style={{ color: "var(--ink)" }}>{propertyInfo.name}</strong> · {propertyInfo.total_units} units</>
                : "Loading property…"
              }
            </p>
          </div>
          {/* Date Filter */}
          <DateNavigator date={selectedDate} onChange={setSelectedDate} />
        </div>
      </div>

      {/* Valet Status Banner */}
      <div className="fu d1" style={{
        background: vsConfig.bg, border: `1.5px solid ${vsConfig.border}`,
        borderRadius: 14, padding: "16px 20px", marginBottom: 20,
        display: "flex", alignItems: "center", gap: 12,
        transition: "all .3s",
      }}>
        <div style={{
          width: 10, height: 10, borderRadius: "50%", flexShrink: 0,
          background: vsConfig.dot,
          boxShadow: valetStatus?.status === "on_site" ? `0 0 0 3px ${vsConfig.dot}33` : "none",
        }} />
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: ".6px", textTransform: "uppercase", color: "var(--mut)", marginBottom: 3 }}>
            Current Valet Status
          </div>
          <div style={{ fontSize: 14.5, fontWeight: 700, color: vsConfig.color }}>
            {vsConfig.label}
          </div>
          {valetStatus?.updated_at && (
            <div style={{ fontSize: 12, color: "var(--mut)", marginTop: 2 }}>
              Last updated: {formatTime(valetStatus.updated_at)}
            </div>
          )}
        </div>
        {isToday && (
          <div style={{
            fontSize: 9, fontWeight: 700, padding: "3px 9px", borderRadius: 20,
            background: "#e3f2fd", color: "#1565c0",
            textTransform: "uppercase", letterSpacing: ".5px",
          }}>Live</div>
        )}
      </div>

      {/* Stats Grid */}
      <div className="fu d2" style={{ fontSize: 10, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: "var(--mut)", marginBottom: 12 }}>
        {isToday ? "Today's Summary" : `Summary for ${formatDate(selectedDate)}`}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: 14, marginBottom: 24 }}>
        <StatCard
          label="Total Units"
          value={loading ? "…" : propertyInfo?.total_units ?? "—"}
          sub="Registered units"
          icon={Building2}
          delay="d1"
        />
        <StatCard
          label="Trash Submissions"
          value={loading ? "…" : submissions.length}
          sub={`of ${propertyInfo?.total_units ?? "—"} units`}
          color="#1565c0"
          icon={Trash2}
          delay="d2"
        />
        <StatCard
          label="Services Completed"
          value={loading ? "…" : servicesCount}
          sub="Valet rounds done"
          color="var(--g600)"
          icon={CheckCircle}
          delay="d3"
        />
        <StatCard
          label="Last Activity"
          value={loading ? "…" : lastActivity ? formatTime(lastActivity) : "—"}
          sub={lastActivity ? "Most recent action" : "No activity"}
          color="#e65100"
          icon={Clock}
          delay="d4"
        />
      </div>

      {/* Submissions Feed */}
      <div className="fu d3">
        <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: "var(--mut)", marginBottom: 12 }}>
          Resident Submissions
        </div>

        {loading ? (
          <div style={{ textAlign: "center", padding: "24px 0", fontSize: 13, color: "var(--mut)" }}>Loading…</div>
        ) : submissions.length === 0 ? (
          <div style={{
            textAlign: "center", padding: "28px",
            background: "#fff", borderRadius: 12, border: "1.5px dashed var(--ln)",
          }}>
            <Trash2 size={26} color="var(--ln)" style={{ marginBottom: 10 }} />
            <div style={{ fontSize: 13, color: "var(--mut)" }}>
              No trash submissions {isToday ? "today" : "on this date"}.
            </div>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {submissions.map((s, i) => (
              <div key={s.id} style={{
                display: "flex", alignItems: "center", gap: 12,
                padding: "12px 16px", borderRadius: 11,
                background: "#fff", border: "1px solid var(--ln)",
                boxShadow: "0 1px 3px rgba(0,0,0,.04)",
              }}>
                <div style={{
                  width: 32, height: 32, borderRadius: 9,
                  background: "var(--g50)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                }}>
                  <Trash2 size={14} color="var(--g600)" />
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: "var(--ink)" }}>
                    Unit #{s.metadata?.unit_number ?? "—"}
                  </div>
                  <div style={{ fontSize: 11.5, color: "var(--mut)", marginTop: 2 }}>
                    {formatTime(s.created_at)}
                  </div>
                </div>
                {i === 0 && isToday && (
                  <span style={{
                    fontSize: 9, fontWeight: 700, padding: "2px 8px", borderRadius: 20,
                    background: "var(--g600)", color: "#fff",
                    textTransform: "uppercase", letterSpacing: ".5px",
                  }}>Latest</span>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

    </DashboardLayout>
  );
}